module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-00.2.b71bdd25.jpg";